import ReactDOM from 'react-dom'

import App from './App'
import { BrowserRouter } from './components/app/BrowserRouter'
import * as serviceWorker from './serviceWorker'
import { history } from './utils/app/history'
import { enableMocks } from '@/mocks/index'

const rootElement = document.querySelector('#root')

// eslint-disable-next-line promise/catch-or-return, unicorn/prefer-top-level-await
enableMocks().then(() => {
    ReactDOM.render(
        <BrowserRouter history={history}>
            <App />
        </BrowserRouter>,
        rootElement,
    )

    return null
})

// If you want your app to work offline and load faster, you can change
// Unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
